/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import { setValidationResult } from '@redux/modules/formGeneration';

const FieldValidator = ({
  validationRules,
  validateFieldName,
  validateFlag,
  validationValue,
  selectedListing,
  setValidateFlag,
  setValidationValue,
  setValidateFieldName,
  runValidation = () => null,
}) => {
  const dispatch = useDispatch();
  const { values } = useFormikContext();

  //  photosHaveChanged, supplementsHaveChanged, roomsHaveChanged, listing, unmodifiedListing, photos, supplements, rooms

  const getRepeatableChanged = (formikGroup, unmodifiedGroup) => {
    /* does origin have this item?
      does any prop of this item not match origin?
     */
    let hasChanged = false;
    if (formikGroup.length !== unmodifiedGroup.length) return true;
    formikGroup.forEach(item => {
      if (hasChanged) return;
      if (item.UniqueID) {
        // room/door/parcel, openhouse?
        const umItem = unmodifiedGroup.find(umi => umi.UniqueID === item.UniqueID);
        Object.keys(item).forEach(itemkey => {
          if (hasChanged) return;
          if (umItem?.[itemkey]) {
            if (umItem[itemkey] !== item[itemkey]) hasChanged = true;
          }
        });
        // see that every key's value in formikElement matches umEl
      } else if (item.URL) {
        // photo or supp
        const umItem = unmodifiedGroup.find(umi => umi.URL === item.URL);
        Object.keys(item).forEach(itemkey => {
          if (hasChanged) return;
          if (umItem?.[itemkey]) {
            if (umItem[itemkey] !== item[itemkey]) hasChanged = true;
          }
        });
      } else {
        // item has neither url or uniqueId;
        hasChanged = true;
      }
    });
    return hasChanged;
  };

  const getChanged = (unModGroup, photosGroup, roomsGroup, supplementsGroup, openHousesGroup) => {
    let photosHaveChanged = false;
    let supplementsHaveChanged = false;
    let roomsHaveChanged = false;
    let openHousesHaveChanged = false;

    photosHaveChanged = getRepeatableChanged(photosGroup, unModGroup.umPhotos);
    supplementsHaveChanged = getRepeatableChanged(supplementsGroup, unModGroup.umSupplements);
    roomsHaveChanged = getRepeatableChanged(roomsGroup, unModGroup.umRooms);
    openHousesHaveChanged = getRepeatableChanged(openHousesGroup, unModGroup.umOpenHouses);

    photosHaveChanged = photosHaveChanged ? 1 : 0;
    supplementsHaveChanged = supplementsHaveChanged ? 1 : 0;
    roomsHaveChanged = roomsHaveChanged ? 1 : 0;
    openHousesHaveChanged = openHousesHaveChanged ? 1 : 0;

    return [photosHaveChanged, supplementsHaveChanged, roomsHaveChanged, openHousesHaveChanged];
  };

  useEffect(() => {
    if (validateFlag === true) {
      values[validateFieldName] = validationValue;

      try {
        if (validationRules.descriptions.logics.includes(`${validateFieldName}Rules`)) { // possessionData, NumofElevators rules do not exist, it will throw an error
          let res;
          const {
            Photos, Rooms, Supplements, OpenHouses, ...resourceData
          } = values;

          if ((validationRules.descriptions.logicName === 'AgentRules') || (validationRules.descriptions.logicName === 'OfficeRules')) {
            res = validationRules.runWithParameters({ name: `${validateFieldName}Rules` }, resourceData);
          } else {
            const unmodifiedListing = selectedListing ? selectedListing.listing : {};
            const unModGroup = {
              umPhotos: selectedListing?.photos ?? [],
              umRooms: selectedListing?.rooms ?? [],
              umSupplements: selectedListing?.supplements ?? [],
              umOpenHouses: selectedListing?.openHouses ?? [],
              umParcels: selectedListing?.parcels ?? [],
              umDoors: selectedListing?.doors ?? [],
            };
            const photosGroup = Photos
              ? Object.keys(Photos).map(key => (!Photos[key].IsDeleted) && Photos[key])
              : [];
            const roomsGroup = Rooms
              ? Object.keys(Rooms).map(key => (!Rooms[key].IsDeleted) && Rooms[key])
              : [];
            const supplementsGroup = Supplements
              ? Object.keys(Supplements).map(key => (!Supplements[key].IsDeleted) && Supplements[key])
              : [];
            const openHousesGroup = OpenHouses
              ? Object.keys(OpenHouses).map(key => (!OpenHouses[key].IsDeleted) && OpenHouses[key])
              : [];

            const [photosHaveChanged, supplementsHaveChanged, roomsHaveChanged, openHousesHaveChanged] = getChanged(unModGroup, photosGroup, roomsGroup, supplementsGroup, openHousesGroup);

            res = validationRules.runWithParameters({ name: `${validateFieldName}Rules` }, photosHaveChanged, supplementsHaveChanged, roomsHaveChanged, openHousesHaveChanged, resourceData, unmodifiedListing, photosGroup, supplementsGroup, roomsGroup);
          }

          const { fieldValidationResult } = res.context.variableContainer;
          dispatch(setValidationResult(fieldValidationResult));
        }
      } catch (er) {
        console.error('Error: FieldValidator getChanged', er);
      }

      setValidateFlag(false); // clear state
      setValidateFieldName('');
      setValidationValue('');
      runValidation();
    }
  }, [validateFlag]);

  return null;
};

export default FieldValidator;
